import React from 'react';
import './App.css';
import MyMaps from './MyMaps';
import "./index.css";
import logo from "./Components/logo_cropped.jpeg"


function App() {
  return (
    <div className="App">
      <MyMaps />
    </div>

  );
}

export default App;
